// src/pages/conocimiento/ConocimientoPage.tsx
import { useState } from 'react';
import { Button } from '@/components/ui';
import { Plus, Search } from 'lucide-react';
import { useArticulos } from '@/hooks/queries/useConocimiento';
import {
  CategoriasSidebar,
  ArticulosList,
  ArticuloFormModal,
  ArticuloFiltros,
  BusquedaConocimiento,
} from './components';
import type { ArticuloFiltros as FiltrosType } from '@/types';

export function ConocimientoPage() {
  const [selectedCategoriaId, setSelectedCategoriaId] = useState<string | null>(null);
  const [filtros, setFiltros] = useState<FiltrosType>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const queryFiltros = {
    ...filtros,
    categoria_id: selectedCategoriaId || undefined,
  };

  const { data: articulos, isLoading } = useArticulos(queryFiltros);

  return (
    <div className="flex h-[calc(100vh-8rem)]">
      {/* Sidebar de categorías */}
      <CategoriasSidebar
        selectedCategoriaId={selectedCategoriaId}
        onSelectCategoria={setSelectedCategoriaId}
      />

      {/* Contenido principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="p-6 border-b bg-white">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-2xl font-bold">Base de Conocimiento</h1>
              <p className="text-gray-500">
                Documentación, FAQs y procedimientos
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="secondary"
                onClick={() => setShowSearch(!showSearch)}
              >
                <Search className="h-4 w-4 mr-2" />
                Buscar
              </Button>
              <Button onClick={() => setIsModalOpen(true)}>
                <Plus className="h-4 w-4 mr-2" />
                Nuevo Artículo
              </Button>
            </div>
          </div>

          {showSearch ? (
            <BusquedaConocimiento />
          ) : (
            <ArticuloFiltros filtros={filtros} onChange={setFiltros} />
          )}
        </div>

        <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
          {!showSearch && (
            <ArticulosList articulos={articulos ?? []} isLoading={isLoading} />
          )}
        </div>
      </div>

      <ArticuloFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
